import React from "react";
export function Footer() {
  return <footer className="bg-navy-950 px-5 pb-32 pt-12 text-center text-white" data-id="element-174" data-mp="19ivlq3plplne">
      <p className="font-display text-[20px] font-black" data-id="element-175" data-mp="206j6dqqc6pi3">DENTAL BLEACHING BLUEPRINT™</p>
      <p className="mt-1 text-[14px] text-white/70" data-id="element-176" data-mp="2f53ah9r2cbd2">Professional Dental Whitening Education · By Dr. Valerica Montes</p>
      <p className="mx-auto mt-6 max-w-2xl text-[13px] leading-relaxed text-white/60" data-id="element-177" data-mp="2a71rspxjue24">
        Educational content for dental professionals. Clinical decisions must be based on individual patient assessment, current scientific
        evidence, and applicable professional regulations.
      </p>
      <p className="mt-6 text-[12px] text-white/50" data-id="element-178" data-mp="1w6r2hrbw17j2">© 2026 Dr. Valerica Montes — DENTAL BLEACHING BLUEPRINT™. All Rights Reserved.</p>
    </footer>;
}